import { FC, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { Row, Col } from "antd";
import { IButton, Popup, Spinner } from "../../../ui-kit";
import { useStatusMessage } from "../../../hooks/useStatusMessage";

import {
  GRID_TYPE_HEATSUPPLY,
  GRID_TYPE_WATERSUPPLY,
  GRID_TYPE_GASCOMMUNICATION,
  GRID_TYPE_LIGHTING,
  GRID_TYPE_DRAINAGE,
  GRID_TYPE_POWERSUPPLY,
  DEFECT_STATUS_CLOSED_ID,
  DEFECT_STATUS_REMOVED_ID,
  DEFECT_STATUS_REJECTED_ID,
  DEFECT_STATUS_AGREED_ID,
} from "../constants";

import DefectHistory from "../data/defectHistory/defectHistory";
import StatusHistory from "../data/statusHistory/statusHistory";
import DefectReject from "./defectReject/defectReject";
import DefectRemove from "./defectRemove/defectRemove";
import DefectNotifyStatus from "../data/defectNotifyStatus/defectNotifyStatus";

import CardWaterSupply from "./cardWaterSupply";
import CardDrainage from "./cardDrainage";
import CardGasСommunication from "./cardGasСommunication";
import CardHeatSupply from "./cardHeatSupply";
import CardLighting from "./cardLighting";
import CardPowerSupply from "./cardPowerSupply";
import CardCommunal from "./cardCommunal";
import DefectCardMedia from "./cardMedia";

import defectCardsStore, { IDefectCard } from "../../../store/defectCards";
import { authStore } from "../../../store/authStore";
import styles from "../Defect.module.scss";
import classNames from "classnames";

interface DefectCardProps {
  index?: number;
  card: IDefectCard;
}

const DefectCard: FC<DefectCardProps> = observer(({ card }) => {
  const {
    defectRejectFormIsOpened,
    defectRemoveFormIsOpened,
    sendDefectStatus,
    defectToMkaIsSending,
    sendDefectToMkaIsOpened,
    defectAgreedIsSending,
    defectToMkaError,
    setDefectsIds,
  } = defectCardsStore;
  const data = card.data;
  const { defectNotify } = authStore;
  const [openPopupDefect, setOpenPopupDefect] = useState<boolean>(false);
  const [openPopupMk, setOpenPopupMk] = useState(false);
  const [checkedMedia, setCheckedMedia] = useState(false);

  useEffect(() => {
    if (data.mediaCoverage == true) {
      setCheckedMedia(true);
    }
  }, [data.mediaCoverage]);

  const handleOpenPopupMk = (): void => {
    setOpenPopupMk((pre) => !pre);
  };

  const handleOpenPopupDefect = (): void => {
    setOpenPopupDefect((pre) => !pre);
  };

  const handleClosePopupDefect = (): void => {
    setOpenPopupDefect((pre) => !pre);
  };

  const handleOpenNotifyForm = () => {
    setDefectsIds(data.id);
  };

  const handleOpenRejectForm = () => {
    defectRejectFormIsOpened.setTrue();
  };

  const handleCloseRejectForm = () => {
    defectCardsStore.closeRejectForm();
  };

  const handleOpenRemoveForm = () => {
    defectRemoveFormIsOpened.setTrue();
  };

  const handleCloseRemoveForm = () => {
    defectCardsStore.closeRemoveForm();
  };

  const handleCloseCard = () => {
    defectCardsStore.removeCard(card.key);
  };

  const handleClickDefectAgreed = () => {
    // подтверждение
    const request = {
      ids: [data.id],
      isValid: data.isValid == false ? true : false,
    };
    defectCardsStore.setCardIsLoading(data.id, true);
    defectCardsStore.sendDefectAgreed(data.id, request, card.key);
    //defectCardsStore.removeCard(card.key);
  };

  const handleCloseDefectToMka = () => {
    defectCardsStore.closeDefectToMkaForm();
  };

  useStatusMessage(sendDefectStatus);

  const handleClickSendDefectToMka = () => {
    defectCardsStore.sendDefectToMka(data.id, data);
  };

  return card.isLoading ? (
    <div className="defect-validator__loader">
      <Spinner size="large" />
    </div>
  ) : (
    <>
      <Row>
        <Col>
          <div className={styles.defect__cardWrapper}>
            <p className={styles.defect__cardTitle}>
              Данные ситуационного управления
            </p>
            {data?.gridTypeId === GRID_TYPE_HEATSUPPLY && (
              <CardHeatSupply
                data={data}
                handleOpenPopupDefect={handleOpenPopupDefect}
              />
            )}
            {data?.gridTypeId === GRID_TYPE_WATERSUPPLY && (
              <CardWaterSupply
                data={data}
                handleOpenPopupDefect={handleOpenPopupDefect}
              />
            )}
            {data?.gridTypeId === GRID_TYPE_GASCOMMUNICATION && (
              <CardGasСommunication
                data={data}
                handleOpenPopupDefect={handleOpenPopupDefect}
              />
            )}
            {data?.gridTypeId === GRID_TYPE_LIGHTING && (
              <CardLighting
                data={data}
                handleOpenPopupDefect={handleOpenPopupDefect}
              />
            )}
            {data?.gridTypeId === GRID_TYPE_DRAINAGE && (
              <CardDrainage
                data={data}
                handleOpenPopupDefect={handleOpenPopupDefect}
              />
            )}
            {data?.gridTypeId === GRID_TYPE_POWERSUPPLY && (
              <CardPowerSupply
                data={data}
                handleOpenPopupDefect={handleOpenPopupDefect}
              />
            )}
          </div>
        </Col>
        <Col span={4}>
          {data.deadlineViolated && (
            <div className={styles.defect__cardTimeLimit}>
              Нарушен срок устранения
            </div>
          )}
          <DefectCardMedia checkedMedia={checkedMedia} data={data} />
          <DefectNotifyStatus defectId={data.id} />
        </Col>
      </Row>

      <div className={styles.defect__cardBtnGroup}>
        <div className={styles.defect__cardBtn}>
          {data.incidentStatusId == DEFECT_STATUS_REMOVED_ID ||
          data.incidentStatusId == DEFECT_STATUS_CLOSED_ID ? (
            <Link
              className={classNames(styles.defect__cardLink)}
              to={`/sp/defectform/${data.id}`}
            >
              Просмотреть дефект
            </Link>
          ) : (
            <Link
              className={classNames(styles.defect__cardLink, {
                [styles["defect__cardLink_disabled"]]:
                  (data.incidentStatusId === DEFECT_STATUS_CLOSED_ID ||
                    data.incidentStatusId === DEFECT_STATUS_REMOVED_ID) &&
                  true,
              })}
              to={`/sp/defectform/${data.id}`}
            >
              Редактировать дефект
            </Link>
          )}
          <Link
            className={classNames(styles.defect__cardLink, {
              [styles["defect__cardLink_disabled"]]:
                (data.incidentStatusId === DEFECT_STATUS_CLOSED_ID ||
                  data.incidentStatusId === DEFECT_STATUS_REMOVED_ID) &&
                true,
            })}
            to={`/sp/defectform/${data.id}/close`}
          >
            Закрыть дефект
          </Link>
          <IButton
            className={styles.defect__cardBtnOutline}
            onClick={handleOpenRemoveForm}
            disabled={
              (data.incidentStatusId === DEFECT_STATUS_CLOSED_ID ||
                data.incidentStatusId === DEFECT_STATUS_REMOVED_ID) &&
              true
            }
          >
            Удалить дефект
          </IButton>
        </div>
        <div className={styles.defect__cardBtn}>
          {authStore && defectNotify && (
            <IButton
              onClick={handleOpenNotifyForm}
              disabled={
                data.incidentStatusId === DEFECT_STATUS_CLOSED_ID ||
                data.incidentStatusId === DEFECT_STATUS_REMOVED_ID
              }
            >
              Отправить уведомление
            </IButton>
          )}
        </div>
        <div className={styles.defect__cardBtn}>
          {authStore && defectNotify && (
            <IButton
              onClick={handleOpenRejectForm}
              disabled={
                (data.incidentStatusId === DEFECT_STATUS_REJECTED_ID ||
                  data.incidentStatusId === DEFECT_STATUS_REMOVED_ID) &&
                true
              }
            >
              Отклонить
            </IButton>
          )}
          {authStore && defectNotify && (
            <IButton
              onClick={handleClickDefectAgreed}
              disabled={
                data.isValid == true ||
                defectAgreedIsSending.value ||
                data.incidentStatusId === DEFECT_STATUS_REMOVED_ID
              }
            >
              Подтвердить
            </IButton>
          )}
          <IButton
            className={styles.defect__cardBtnOutline}
            onClick={handleCloseCard}
          >
            Отмена
          </IButton>
        </div>
      </div>

      <Popup
        open={openPopupDefect}
        onClose={handleClosePopupDefect}
        title={`История изменений статуса дефекта № ${data.id}`}
      >
        <StatusHistory defectId={data.id} />
        <DefectHistory defectId={data.id} />
      </Popup>

      <Popup
        open={defectRejectFormIsOpened.value}
        onClose={handleCloseRejectForm}
        title={`Отклонить дефект № ${data.id}`}
      >
        <DefectReject
          data={data}
          targetKey={card.key}
          onClose={handleCloseRejectForm}
        />
      </Popup>

      <Popup
        open={defectRemoveFormIsOpened.value}
        onClose={handleCloseRemoveForm}
        title={`Удалить дефект № ${data.id}`}
      >
        <DefectRemove
          defectId={data.id}
          targetKey={card.key}
          onClose={handleCloseRemoveForm}
        />
      </Popup>
      <Popup
        open={sendDefectToMkaIsOpened.value}
        onClose={handleCloseDefectToMka}
        title={"Ошибка загрузки в МКА ЖКХ"}
      >
        <div className={styles.uploadDefectContainer}>{defectToMkaError}</div>
      </Popup>
    </>
  );
});

export default DefectCard;
